import React, { useState, useEffect, useRef } from 'react'
import { useHistory, useParams, Link, useLocation } from 'react-router-dom'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import * as Constants from '../../../../_config/app'

//images
import clientDataIcon from '../../../../assets/img/icons/client-data.png'
import forRepairIcon from '../../../../assets/img/icons/for-repair.png'
import visitationIcon from '../../../../assets/img/icons/visitation.png'
import infoIcon from '../../../../assets/img/icons/info-black.png'
import loader from '../../../../assets/img/loader.svg'
import carIcon from '../../../../assets/img/icons/car.png'

//modals
import Success from '../../../modals/messages/Success'
import Error from '../../../modals/messages/Error'
import Question from '../../../modals/messages/Question'
import QuestionRemove from '../../../modals/messages/Question'
import Dropdown from '../../../partials/Dropdown'
import Employees from './modals/Employees'
import { useAuthDataContext } from '../../../../_providers/Auth'
import Address from './modals/Address'
import ReactTooltip from 'react-tooltip'

//NEW: За реф към допълнителния модал
import AddOrEditSmsMessage from '../../sms/text-messages/AddOrEdit'
import AppliancesField from './AppliancesField'
import ReservationImages from './ReservationImages'
import TaskInfoComments from './TaskInfoComments'
import TaskInfoTodos from './TaskInfoTodos'
import AddComment from './modals/AddComment'
import { createPortal } from 'react-dom'
import { Box, Button, Checkbox, FormControlLabel, Menu, MenuItem, Paper, Popper, Skeleton } from '@mui/material'

// images
import dropdownArrowImage from "@/assets/img/icons/select-arrow.svg"
import complaintImage from "@/assets/img/reservations/icons/complaint.svg"
import continueImage from "@/assets/img/reservations/icons/continue.svg"
import createNewImage from "@/assets/img/reservations/icons/create-new.svg"
import duplicationImage from "@/assets/img/reservations/icons/duplication.svg"
import removeImage from "@/assets/img/reservations/icons/remove.svg"
import sendNotificationImage from "@/assets/img/reservations/icons/send-notification.svg"
import sendOtherImage from "@/assets/img/reservations/icons/send-other.svg"
import sendSmsImage from "@/assets/img/reservations/icons/send-sms.svg"
import clientHeadImage from "@/assets/img/reservations/icons/client-head.svg"
import visitpriceHeadImage from "@/assets/img/reservations/icons/visitprice-head.svg"
import hastagImage from "@/assets/img/reservations/icons/hashtag.svg"
import calendarImage from "@/assets/img/reservations/icons/calendar.svg"
import toggleReservationCloseIcon from '@/assets/img/reservations/icons/toggle-reservation-close.svg'
import toggleReservationOpenIcon from '@/assets/img/reservations/icons/toggle-reservation-open.svg'

// components
import TaskInfoCustomHeadTabs from '@/components/pages/reservation/partials/TaskInfoCustomHeadTabs'
import TaskInfoInvoiceFields from './TaskInfoInvoiceFields'
import PhoneField from '@/components/partials/PhoneField'

// hoks
import useReservationOpenToggle from '@/_helpers/useReservationOpenToggle'

let timeout

function TaskInfo(props) {
    const { loadingReservationOpenToggle, toggleReservationOpen } = useReservationOpenToggle()

    const auth = useAuthDataContext()
    const params = useParams()
    const history = useHistory()
    const location = useLocation()

    const editMode = params.id ? true : false

    const setOriginal = props.setOriginal
    const isAddress = props.isAddress
    const isOnSiteRepair = props.isOnSiteRepair
    const getResTypeId = props.getResTypeId
    const getResType = props.getResType
    const handleSetLoadingOnDelete = props.handleSetLoadingOnDelete

    const searchParams = new URLSearchParams(location.search)

    const redirect = searchParams.get('redirect') || false

    //refs
    const replicateModalRef = useRef(null)
    const continueModalRef = useRef(null)
    const reclamationModalRef = useRef(null)
    const successModalRef = useRef(null)
    const employeesModalRef = useRef(null)
    const inputModelsRef = useRef(null)
    const reportModalRef = useRef(null)
    const successMailModalRef = useRef(null)
    const errorModalRef = useRef(null)
    const addressModalRef = useRef(null)
    const applianceModalRef = useRef(null)
    const workDayModalRef = useRef(null)
    const addAddressReservationButtonRef = useRef(null)
    const messageTemplatesButtonRef = useRef(null)
    const questionRemoveModalRef = useRef(null)
    const addCommentModalRef = useRef(null)
    const prevRefreshKeyRef = useRef(props.refreshKey)
    const pendingRefreshRef = useRef(false)
    const prevPropsDataRef = useRef(props.data)

    const initialValidations = {}

    const [messageTemplates, setmessageTemplates] = useState([])
    const [loading, setLoading] = useState(false)
    const [showDropdown, setShowDropdown] = useState(false)

    const [applianceForms, setApplianceForms] = useState([{}])
    const [additionalPhoneForms, setAdditionalPhoneForms] = useState([{}])

    const [openButtonDropdown, setOpenButtonDropdown] = useState(null)
    const [openApplianceDropdown, setOpenApplianceDropdown] = useState(null)

    //NEW: Реф за да отворим допълнителния модал
    const smsModalRef = useRef(null)

    //NEW: Допълнителни телефонни номера
    const countryCodes = [
        { value: '+359', label: 'BG (+359)' },
        { value: '+1', label: 'TR (+90)' },
        { value: '+44', label: 'UK (+44)' },
    ]

    const handleNewAppliance = () => {
        setApplianceForms(prev => [...prev, {}])
    }

    //NEW: Допълнителни телефонни номера
    const handleAdditionalPhoneChange = (idx, field, value) => {
        setTask(prev => {
            const updatedPhones = [...(prev.data.phones || [])]
            updatedPhones[idx] = {
                ...updatedPhones[idx],
                [field]: value
            }
            return {
                ...prev,
                data: {
                    ...prev.data,
                    phones: updatedPhones
                }
            }
        })
    }

    const handleAddAdditionalPhone = () => {
        setTask(prev => ({
            ...prev,
            data: {
                ...prev.data,
                phones: [...(prev.data.phones || []), { country_code: '+359', phone_number: '', contact_person_name: '' }]
            }
        }))
    }

    const handleRemoveAdditionalPhone = idx => {
        setTask(prev => {
            const updatedPhones = [...(prev.data.phones || [])]
            updatedPhones.splice(idx, 1)
            return {
                ...prev,
                data: {
                    ...prev.data,
                    phones: updatedPhones
                }
            }
        })
    }

    const handleCountryCodeChange = (index, value) => {
        setTask(prev => {
            const updatedCodes = [...(prev.data.country_codes || [])]
            updatedCodes[index] = value

            return {
                ...prev,
                data: {
                    ...prev.data,
                    country_codes: updatedCodes
                }
            }
        })
    }

    const fetchMessageTemplates = async () => {
        if (messageTemplates.length > 0) return

        setLoading(true)

        try {
            const response = await Api.get('text-messages/all')
            setmessageTemplates(response.data.data)
        } catch (error) {
            console.error('Error fetching messageTemplates:', error)
        } finally {
            setLoading(false)
        }
    }

    const handleOptionClick = async (option) => {
        try {
            console.log('Selected option:', option.id)
            smsModalRef.current.edit(option.id, { customHeading: 'customHeading' })
        } catch (error) {
            console.error('Error processing option:', error)
        }
    }

    let hasPerformer = Boolean(props.data.performer)
    let hasId = Boolean(props.data.id)

    const [task, setTask] = useState({
        validations: initialValidations,
        loading: false,
        dataLoaded: hasId ? false : true,
        contractors: {
            types: [],
            all: []
        },
        appliances: {
            categories: [],
            originalCategories: [],
            brands: [],
            models: [],
        },
        employees: {
            all: []
        },
        reservations: {
            statuses: [],
            visitperiods: [],
            types: []
        },
        data: {
            phones: [],
            subscription_id: null,
            warranty_id: null,
            subscriptions: [],
            warranties: [],
            parts_provider: '',
        },
        canSendReport: false,
        tabsCount: {},
    })

    let contractorId = task.data.contractor ? task.data.contractor.id : ''
    let contractorTypeId = task.data.contractor ? task.data.contractor.type_id : ''


    const setAppliances = (arr) => {
        props.setOriginal({
            ...props.data,
            appliances: arr
        })
    }

    useEffect(() => {
        Api.get('partners/categories/all')
            .then(res => {
                setTask(task => ({
                    ...task,
                    appliances: {
                        ...task.appliances,
                        categories: res.data,
                        originalCategories: res.data,
                        brands: [],
                        models: []
                    }
                }))
            })

        Api.get('reservations/statuses')
            .then(res => {
                setTask(task => ({
                    ...task,
                    reservations: {
                        ...task.reservations,
                        statuses: res.data
                    }
                }))
            })

        Api.get('reservations/visitperiods')
            .then(res => {
                setTask(task => ({
                    ...task,
                    reservations: {
                        ...task.reservations,
                        visitperiods: Array.isArray(res.data) ? res.data : []
                    }
                }))
            })

        Api.get('reservations/types')
            .then(res => {
                setTask(task => ({
                    ...task,
                    reservations: {
                        ...task.reservations,
                        types: res.data
                    }
                }))
            })

    }, [])

    useEffect(() => {

        if (typeof props.data === 'object') {
            // An explicit refreshData() from the parent bumps refreshKey — treat that
            // as a request to pull authoritative server state, bypassing the local-edit guard.
            // refreshKey changes before the async re-fetch lands, so we arm a pending flag and
            // only force the sync once the fresh props.data actually arrives.
            if (props.refreshKey !== prevRefreshKeyRef.current) {
                prevRefreshKeyRef.current = props.refreshKey
                pendingRefreshRef.current = true
            }

            const propsDataChanged = props.data !== prevPropsDataRef.current
            prevPropsDataRef.current = props.data

            let forceSync = false
            if (pendingRefreshRef.current && propsDataChanged) {
                forceSync = true
                pendingRefreshRef.current = false
            }

            setTask(task => {
                // Skip update if key data hasn't changed to avoid overwriting local modifications
                const propsDataId = props.data?.id
                const taskDataId = task.data?.id
                const propsContractorId = props.data?.contractor?.id
                const taskContractorId = task.data?.contractor?.id

                // Only sync from parent on initial load or when core data (id, contractor) changes
                const shouldSync = forceSync || !taskDataId || (propsDataId && propsDataId !== taskDataId) ||
                    (propsContractorId && propsContractorId !== taskContractorId)

                if (!shouldSync && task.dataLoaded) {
                    // Data already loaded and no significant changes - keep local state
                    return {
                        ...task,
                        loading: false,
                        dataLoaded: true
                    }
                }

                const resolvedIsLandlord = task.data.is_landlord !== undefined
                    ? task.data.is_landlord
                    : (props.data.is_landlord ?? props.data.customer?.is_landlord)

                return {
                    ...task,
                    data: {
                        ...props.data,
                        is_landlord: resolvedIsLandlord
                    },
                    loading: false,
                    dataLoaded: true,
                }
            })
        }

    }, [props.data, props.refreshKey])

    useEffect(() => {
        if (props.settings) {
            setTask(task => ({
                ...task,
                data: {
                    ...task.data,
                    calculate_labour_price: props.settings.labour_price_type
                }
            }))
        }
    }, [props.settings])

    useEffect(() => {
        if (task.data?.id) {
            setTask(task => ({
                ...task,
                dataLoaded: true,
            }))
        }
    }, [task.data?.id])

    useEffect(() => {
        setTask(task => ({
            ...task,
            tabsCount: props.tabsCount
        }))
    }, [props.tabsCount])

    useEffect(() => {
        let categoryId = task.data?.appliancecategory?.id

        if (categoryId) {
            let items = task.appliances.categories

            let exists = items.filter(c => {
                return Number(c.id) === Number(categoryId)
            }).length

            if (!exists) {
                items.push(task.data.appliancecategory)

                setTask(prev => ({
                    ...prev,
                    appliances: {
                        ...prev.appliances,
                        categories: items
                    }
                }))
            }
        }
    }, [task.appliances.categories, task.data.appliancecategory])

    useEffect(() => {

        let catId = task.data?.appliancecategory?.id

        if (!catId) {
            return
        }

        Api.get(`partners/brands/all?category_id=${catId}`)
            .then(res => {
                setTask(task => ({
                    ...task,
                    appliances: {
                        ...task.appliances,
                        brands: res.data,
                    }
                }))
            })
    }, [task.data.appliancecategory])

    useEffect(() => {
        let brandId = task.data?.appliancebrand?.id

        if (brandId) {
            let items = task.appliances.brands

            let exists = items.filter(c => {
                return Number(c.id) === Number(brandId)
            }).length

            if (!exists) {
                items.push(task.data.appliancebrand)

                setTask(prev => ({
                    ...prev,
                    appliances: {
                        ...prev.appliances,
                        brands: items
                    }
                }))
            }
        }
    }, [task.appliances.brands, task.data.appliancebrand])

    useEffect(() => {

        // let catId = task.data.appliancecategory.id;
        // let brandId = task.data.appliancebrand ? task.data.appliancebrand.id : null;

        // if (!catId || !brandId) {
        //     return;
        // }

        // Api.get(`appliances/models/all?category_id=${catId}&brand_id=${brandId}`)
        //     .then(res => {
        //         setTask(task => ({
        //             ...task,
        //             appliances: {
        //                 ...task.appliances,
        //                 models: res.data
        //             }
        //         }))
        //     })


        // ако са заредени категориите и марките да нулира полето за модел при промяна
        if (task.appliances.categories.length && task.appliances.brands.length) {
            if (inputModelsRef.current) {
                // inputModelsRef.current.reset();
            }
        }

    }, [task.data.appliancecategory, task.data.appliancebrand])

    useEffect(() => {
        let contractor = task.contractors.all.find(c => Number(c.id) === Number(task.data?.contractor?.id))

        let subscriptions = (function () {
            let subscriptions = contractor && Array.isArray(contractor.activesubscriptions) ? contractor.activesubscriptions : []

            // console.log(subscriptions);

            let current = task.data.subscription

            if (current) {
                let currentExists = subscriptions.find(s => s.id === current.id)

                if (!currentExists) {
                    subscriptions.push(current)
                }
            }

            return subscriptions
        })()

        let warranties = (function () {
            let warranties = contractor && Array.isArray(contractor.activewarranties) ? contractor.activewarranties : []

            // console.log(warranties);

            let current = task.data.warranty

            if (current) {
                let currentExists = warranties.find(s => s.id === current.id)

                if (!currentExists) {
                    warranties.push(current)
                }
            }

            return warranties
        })()

        // console.log(contractor);

        setTask(prev => ({
            ...prev,
            subscriptions: subscriptions,
            warranties: warranties,
        }))
    }, [task.data.contractor, task.contractors.all])

    useEffect(() => {
        Api.get('contractors/types')
            .then(res => {

                let items = res.data || []

                if (props.data.contractor && props.data.contractor.type) {
                    let exists = items.filter(c => {
                        return Number(c.id) === Number(props.data.contractor.type_id)
                    }).length

                    if (!exists) {
                        items.push(props.data.contractor.type)
                    }
                }

                setTask(task => ({
                    ...task,
                    contractors: {
                        ...task.contractors,
                        types: items
                    }
                }))
            })
    }, [props.data.contractor])

    useEffect(() => {
        if (contractorTypeId) {

            let url = 'contractors/with-appliances?type_id=' + contractorTypeId

            if (!hasId) {
                url += '&active=1'
            }

            Api.get(url)
                .then(res => {

                    let items = res.data.items || res.data

                    if (contractorId) {
                        let exists = items.filter(c => {
                            return Number(c.id) === Number(contractorId)
                        }).length

                        if (!exists) {
                            items.push(task.data.contractor)
                        }
                    }

                    setTask(task => ({
                        ...task,
                        contractors: {
                            ...task.contractors,
                            all: items
                        },
                    }))
                })
        }

    }, [contractorTypeId])

    useEffect(() => {
        if (task.reservations.visitperiods && task.reservations.visitperiods.length === 0) {
            return
        }

        let visitperiod = task.reservations.visitperiods.filter(p => Number(p.id) === Number(task.data.visit_period_id))[0]

        setTask(prev => ({
            ...prev,
            data: {
                ...prev.data,
                visitperiod: visitperiod
            }
        }))

    }, [task.data.visit_period_id, task.reservations.visitperiods])

    // useEffect(() => {
    //     console.log(task.data?.performer)
    // }, [task.data?.performer]);

    // useEffect(() => {
    //     let region = task.data.region;
    //     let town = task.data.town;
    //     let postcode = task.data.postcode;
    //     let street = task.data.address;
    //     let no = task.data.address_no;

    //     if (!region || !town || !street) {
    //         return;
    //     }

    //     let full = [];

    //     if (no) {
    //         full.push(no);
    //     }

    //     full.push(street);

    //     clearTimeout(timeout);

    //     timeout = setTimeout(() => {
    //         Axios.get('https://nominatim.openstreetmap.org/search', {
    //             params: {
    //                 street: full.join(' '),
    //                 county: region,
    //                 city: town,
    //                 postalcode: postcode,
    //                 format: 'json'
    //             }
    //         }).then(res => {
    //             let lat = 0;
    //             let lon = 0;

    //             if (res.data.length) {
    //                 let result = res.data[0];

    //                 if (result.lat) {
    //                     lat = result.lat;
    //                     lon = result.lon;
    //                 }
    //             }

    //             setTask(prev => ({
    //                 ...prev,
    //                 data: {
    //                     ...prev.data,
    //                     lat: lat,
    //                     lon: lon
    //                 }
    //             }));
    //         });
    //     }, 300);
    // }, [task.data.region, task.data.town, task.data.postcode, task.data.address, task.data.address_no])

    useEffect(() => {
        if (props.addMode) {
            clearTimeout(timeout)

            timeout = setTimeout(() => {
                calculatePrice()
            }, 300)
        }
    }, [
        task.data.contractor,
        task.data.lat,
        task.data.lon,
        task.appliances.categories,
        task.data.appliances,
        task.data.appliancecategory,
        task.data.appliancebrand,
        task.data.visit_date_ymd,
        task.data.performer_id,
        task.data.performer_type,
        task.data.initial_status_id,
        task.data.final_status_id,
        task.data.postcode,
        task.data.calculate_labour_price,
        task.data.customer_fault,
        task.data.is_warranty,
        task.data.is_subscription,
        task.data.work_hours,
    ])


    useEffect(() => {
        if (!props.addMode) {
            clearTimeout(timeout)

            timeout = setTimeout(() => {
                calculatePrice()
            }, 300)
        }
    }, [
        task.data.contractor,
        task.appliances.categories,
        task.data.appliances,
        task.data.appliancecategory,
        task.data.appliancebrand,
        task.data.postcode,
        task.data.initial_status_id,
        task.data.calculate_labour_price,
        task.data.customer_fault,
        task.data.is_warranty,
        task.data.is_subscription,
        task.data.work_hours,
    ])

    const calculatePrice = () => {

        let url = 'reservations/calculate-price'

        let form = document.getElementById('reservation')

        if (!form) {
            return
        }

        let data = new FormData(form)

        if (task.data.id) {
            data.append('id', task.data.id)
        }

        data.append('res_type_id', getResTypeId())

        // Add shared reservation parameters
        const isShared = searchParams.get('is_shared')
        const sharedByTenantId = searchParams.get('shared_by_tenant_id')
        const currentTenantId = searchParams.get('current_tenant_id')

        if (isShared === 'true') {
            data.append('is_shared', 'true')
        }

        if (sharedByTenantId) {
            data.append('shared_by_tenant_id', sharedByTenantId)
        }

        if (currentTenantId) {
            data.append('current_tenant_id', currentTenantId)
        }

        Api.post(url, data)
            .then(res => {
                delete res.data.work_hours

                Object.entries(res.data).map(p => {
                    console.log({
                        [p[0]]: p[1]
                    })
                    setTask(prev => ({
                        ...prev,
                        data: {
                            ...prev.data,
                            [p[0]]: p[1]
                        }
                    }))
                })
            })
    }

    const handleContractorsAll = e => {
        let id = e.target.value

        setTask(task => ({
            ...task,
            data: {
                ...task.data,
                contractor: {
                    // ...task.data.contractor,
                    type_id: id,
                    id: null
                },
                is_subscription: false,
                subscription: null,
                subscription_id: null,
                warranty: null,
                warranty_id: null,
                is_warranty: false
            }
        }))
    }

    const handleSelectedContractor = e => {
        let val = e.target.value

        let selected = task.contractors.all.filter(each => {
            return Number(each.id) === Number(val)
        })[0]

        setTask(prev => ({
            ...prev,
            data: {
                ...prev.data,
                contractor: selected,
                contractor_id: selected?.id || null,
                subscription: null,
                is_subscription: false,
                email: selected.email,
                invoice_name: selected.charge ? selected.name : prev.invoice_name,
                invoice_eikegn: selected.charge ? selected.eik : prev.invoice_eikegn,
                invoice_vat_number: selected.charge ? selected.vat_number : prev.invoice_vat_number,
                invoice_mol: selected.charge ? selected.mol : prev.invoice_vat_number,
                invoice_address: selected.charge ? selected.address : prev.invoice_address,
            },
        }))
    }

    const handleSelectSubscription = e => {
        let id = e.target.value

        let contractor = task?.data?.contractor
        let subscriptions = task.subscriptions

        let selected = subscriptions.find(s => Number(s.id) === Number(id))

        setTask(task => ({
            ...task,
            data: {
                ...task.data,
                subscription: selected || null,
                subscription_id: selected?.id || null,
                is_subscription: !!selected,
                warranty: null,
                warranty_id: null,
                is_warranty: false,
                appliancecategory: selected?.appliancecategory || {},
                appliancebrand: selected?.appliancebrand || {},
                appliancemodel: selected?.appliancemodel || {},
                serial_no: selected?.serial_no || null,
                product_code: selected?.product_code || null,
            },
        }))
    }

    const handleSelectWarranty = e => {
        let id = e.target.value

        let contractor = task?.data?.contractor
        let warranties = task.warranties

        let selected = warranties.find(s => Number(s.id) === Number(id))

        setTask(task => ({
            ...task,
            data: {
                ...task.data,
                warranty: selected || null,
                warranty_id: selected?.id || null,
                is_warranty: !!selected,
                subscription: null,
                subscription_id: null,
                is_subscription: false,
                appliancecategory: selected?.appliancecategory || {},
                appliancebrand: selected?.appliancebrand || {},
                appliancemodel: selected?.appliancemodel || {},
                serial_no: selected?.serial_no || null,
                product_code: selected?.product_code || null,
            },
        }))
    }

    const handleSelectDevice = e => {
        let id = e.target.value

        let selected = task.appliances.categories.find(c => Number(c.id) === Number(id))

        setTask(task => ({
            ...task,
            data: {
                ...task.data,
                appliancecategory: {
                    ...task.data.appliancecategory,
                    ...selected,
                    id: id,
                },
                appliancebrand: {},
                appliancemodel: {}
            },
            appliances: {
                ...task.appliances,
                brands: [],
                models: []
            }
        }))

        if (inputModelsRef.current) {
            inputModelsRef.current.reset()
        }

    }

    const handleSelectBrand = e => {
        let id = e.target.value

        setTask(task => ({
            ...task,
            data: {
                ...task.data,
                appliancebrand: {
                    ...task.data.appliancebrand,
                    id: id,
                },
                appliancemodel: {}
            },
            appliances: {
                ...task.appliances,
                models: []
            }
        }))

        if (inputModelsRef.current) {
            inputModelsRef.current.reset()
        }

    }

    const handleSelectModel = e => {
        let id = e.target.value

        setTask(task => ({
            ...task,
            data: {
                ...task.data,
                appliancemodel: {
                    ...task.data.appliancemodel,
                    id: id,
                }
            }
        }))
    }

    const handleSubmit = e => {
        e.preventDefault()
    }

    const handleSave = (e, redirect = false) => {
        e.preventDefault()

        // дали техника може да ремонтира избрания уред
        // и дали е в работното му време
        if (task.data?.performer?.type === 'App\\Employee' || task.data?.performer?.type === 'App\\Models\\Employee') {
            if (typeof task.data.performer.can_repair_appliance !== 'undefined' && !task.data.performer.can_repair_appliance) {
                let modal = applianceModalRef.current

                modal.open()

                return
            }

            // else if (typeof task.data.performer.in_work_day !== 'undefined' && !task.data.performer.in_work_day) {
            //     let modal = workDayModalRef.current;

            //     modal.open();

            //     return;
            // }
        }

        setTask(task => ({
            ...task,
            validations: initialValidations,
            loading: true,
        }))

        let url = editMode ? 'reservations/edit' : 'reservations/add'

        let form = document.getElementById('reservation')

        let data = new FormData(form)

        if (task.data.id) {
            data.append('id', task.data.id)
        }

        {/* //NEW: Допълнителни телефонни номера */ }
        const phones = [...(task.data.phones || [])].map(phone => ({
            id: phone.id, // if editing existing
            country_code: phone.country_code,
            phone_number: phone.phone_number,
            contact_person_name: phone.contact_person_name
        }))

        data.append('phones', JSON.stringify(phones))

        data.append('res_type_id', getResTypeId())

        Api.post(url, data)
            .then(res => {

                // let modal = successModalRef.current

                // modal.open()
                // modal.onClose(() => {

                if (task.canSendReport) {
                    let reportModal = reportModalRef.current

                    reportModal.open()

                    reportModal.onSuccess(() => {
                        sendReport()
                    })

                    reportModal.onClose(() => {
                        finishSaving({
                            ...res.data,
                            phones: res.data.customer?.phones || []
                        }, redirect)
                    })
                } else {
                    finishSaving({
                        ...res.data,
                        phones: res.data.customer?.phones || []
                    }, redirect)
                }

                // })

            })
            .catch(error => {
                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    const fieldErrors = _err.data.errors || _err.data
                    for (let [input, err] of Object.entries(fieldErrors)) {
                        setTask(task => ({
                            ...task,
                            validations: {
                                ...task.validations,
                                [input]: true
                            },
                        }))
                    }
                    if (_err.data.message) {
                        errorModalRef.current.open(_err.data.message)
                    }
                } else if (_err && _err.status && _err.status == 423) {
                    errorModalRef.current.open(_err.data.error)
                } else {
                    errorModalRef.current.open()
                }
            })
            .finally(() => {
                setTask(task => ({
                    ...task,
                    loading: false,
                }))
            })
    }

    const handleSaveExit = e => {
        e.preventDefault()

        let url = redirect

        if (!url) {
            url = 'reservations'

            if (params.id) {
                url += '?id=' + params.id
            }
        }

        handleSave(e, url)
    }

    const finishSaving = (data, redirect = false) => {

        return history.push(`/schedule/reservations/view/${data.id}`)

        if (redirect) {
            return history.push('/' + redirect)
        }

        if (!hasId) {
            return history.push('/schedule/reservations/edit/' + data.id)
        }

        const taskAppliances = Array.isArray(task.data.appliances) ? task.data.appliances : []
        const normalizedAppliances = Array.isArray(data.appliances)
            ? data.appliances.map((ap, i) => {
                const existing = taskAppliances[i] || {}
                return {
                    ...existing,
                    id: ap.id,
                    appliancecategory: ap.appliancecategory?.name ? ap.appliancecategory : existing.appliancecategory,
                    appliancebrand: ap.appliancebrand?.name ? ap.appliancebrand : existing.appliancebrand,
                    appliancemodel: ap.appliancemodel?.name ? ap.appliancemodel : existing.appliancemodel,
                }
            })
            : taskAppliances

        const normalizedData = { ...data, appliances: normalizedAppliances }

        setTask(task => ({
            ...task,
            loading: false,
            data: normalizedData
        }))

        setOriginal(normalizedData)

    }

    const sendReport = () => {
        Api.post('reservations/send-report', {
            id: task.data.id
        }).then(res => {
            if (res.data.success) {
                setTask(prev => ({
                    ...prev,
                    canSendReport: false
                }))
                successMailModalRef.current.open()
            }
        })
    }

    const handleChangePerformer = e => {
        let id = e ? e.id : ''

        setTask(prev => ({
            ...prev,
            data: {
                ...prev.data,
                performer_id: id,
                performer: e
            }
        }))

    }

    const handleChangeAddress = (name, lat, lon) => {
        setTask(prev => ({
            ...prev,
            data: {
                ...prev.data,
                address: name,
                lat: lat ? Number(lat) : null,
                lon: lon ? Number(lon) : null
            }
        }))
    }

    const handleChangeInitialStatus = e => {
        let id = Number(e.target.value)

        setTask(task => ({
            ...task,
            data: {
                ...task.data,
                initial_status_id: id
            }
        }))

    }

    const handleChangeFinalStatus = e => {
        let id = Number(e.target.value)

        setTask(task => ({
            ...task,
            data: {
                ...task.data,
                final_status_id: id
            },
            canSendReport: true
        }))
    }

    const handleChangePeriod = e => {
        let id = Number(e.target.value)

        setTask(task => ({
            ...task,
            data: {
                ...task.data,
                visit_period_id: id
            }
        }))
    }

    const handleChangeDate = e => {
        let val = e.target.value

        setTask(task => ({
            ...task,
            data: {
                ...task.data,
                visit_date_ymd: val
            }
        }))
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setTask(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }

        }))
    }

    const handleTypeChange = data => {

        let inSeconds = 0
        let inMins = 0

        if (data.id) {
            inSeconds = data.time
            inMins = data.minutes
        } else {
            let parse = data.name.match(/\d+/)

            if (parse) {
                inSeconds = parse[0] * 60
                inMins = data.name
            }
        }

        setTask(prev => ({
            ...prev,
            data: {
                ...prev.data,
                type_id: data.id || '',
                exec_time: inSeconds, // в секунди
                exec_time_in_minutes: inMins
            }
        }))
    }

    const showEmployeesSelect = () => {
        employeesModalRef.current.open()
    }

    const showAddressMap = () => {
        addressModalRef.current.open()
    }

    const handleCheckboxChange = e => {
        let name = e.target.name

        setTask(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: !prev.data[name]
            }
        }))
    }

    const handleCustomerInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setTask(prev => ({
            ...prev,
            data: {
                ...prev.data,
                customer: {
                    [name]: val
                }
            }
        }))
    }

    const handleCustomerChange = data => {
        setTask(prev => ({
            ...prev,
            data: {
                ...prev.data,
                customer: {
                    name: data.name,
                }
            }
        }))

        if (data.id) {
            setTask(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    customer: {
                        lastname: data.lastname,
                    },
                    phone: !prev.data.phone ? data.phone : prev.data.phone,
                    email: !prev.data.email ? data.email : prev.data.email,
                    // region: !prev.data.region ? data.region : prev.data.region,
                    // town: !prev.data.town ? data.town : prev.data.town,
                    postcode: !prev.data.postcode ? data.postcode : prev.data.postcode,
                    address: !prev.data.address ? data.address : prev.data.address,
                    // address_no: !prev.data.address_no ? data.address_no : prev.data.address_no,
                    lat: !prev.data.lat ? data.lat : prev.data.lat,
                    lon: !prev.data.lon ? data.lon : prev.data.lon,
                    invoice_name: !prev.data.invoice_name ? `${data.name} ${data.lastname}` : prev.data.invoice_name,
                    invoice_address: !prev.data.invoice_address ? data.address : prev.data.invoice_address,
                    is_landlord: data.is_landlord
                }
            }))
        }
    }

    const handleCreate = () => {
        window.location = '/schedule/reservations/' + getResType() + '/add'
        setOpenButtonDropdown(null)
    }

    const handleContinue = () => {
        setOpenButtonDropdown(null)

        Api.post('reservations/continue', {
            id: task.data.id
        }).then(res => {
            if (res.data.id) {
                history.push('/schedule/reservations/edit/' + res.data.id)

                // continueModalRef.current.open()
            }
        }).catch(err => {
            errorModalRef.current.open()
        })
    }

    const handleReplicate = () => {
        setOpenButtonDropdown(null)

        Api.post('reservations/replicate', {
            id: task.data.id
        }).then(res => {
            if (res.data.id) {
                history.push('/schedule/reservations/edit/' + res.data.id)

                // replicateModalRef.current.open()
            }
        }).catch(err => {
            errorModalRef.current.open()
        })
    }

    function handleToggleReservationOpen() {
        setOpenButtonDropdown(null)

        // If the reservation is open, force the user to add a comment first.
        // Only after the comment is successfully saved do we toggle it.
        if (task.data.is_open) {
            addCommentModalRef.current.open(task.data.id)
            return
        }

        toggleReservationOpen(!task.data.is_open, task.data.id, props.refreshData)
    }

    const handleCommentAddedBeforeToggle = () => {
        toggleReservationOpen(!task.data.is_open, task.data.id, props.refreshData)
    }

    const handleReclamation = () => {
        setOpenButtonDropdown(null)

        Api.post('reservations/reclamation', {
            id: task.data.id
        }).then(res => {
            if (res.data.id) {
                history.push('/schedule/reservations/edit/' + res.data.id)

                // reclamationModalRef.current.open()
            }
        }).catch(err => {
            errorModalRef.current.open()
        })
    }

    const handleSendReport = () => {
        setOpenButtonDropdown(null)

        Api.post('reservations/send-report', {
            id: task.data.id
        }).then(res => {
            if (res.data.success) {
                successMailModalRef.current.open()
            } else {
                errorModalRef.current.open()
            }
        }).catch(err => {
            errorModalRef.current.open()
        })
    }

    const handleSendConfirmation = () => {
        setOpenButtonDropdown(null)

        Api.post('reservations/send-confirmation', {
            id: task.data.id
        }).then(res => {
            if (res.data.success) {
                // successMailModalRef.current.open()
            } else {
                errorModalRef.current.open()
            }
        }).catch(err => {
            errorModalRef.current.open()
        })
    }

    const handleSendCompletion = () => {
        setOpenButtonDropdown(null)

        Api.post('reservations/send-completion-details', {
            id: task.data.id
        }).then(res => {
            if (res.data.success) {
                successMailModalRef.current.open()
            } else {
                errorModalRef.current.open()
            }
        }).catch(err => {
            errorModalRef.current.open()
        })
    }

    const handleSendSms = () => {
        setOpenButtonDropdown(null)

        Api.post('reservations/send-sms-details', {
            id: task.data.id
        }).then(res => {
            if (res.data.success) {
                // successMailModalRef.current.open()
            } else {
                errorModalRef.current.open()
            }
        }).catch(err => {
            errorModalRef.current.open()
        })
    }

    const handleShowPdfOrder = () => {
        setOpenButtonDropdown(null)

        window.open(Constants.App.api + 'reservations/pdf-order?id=' + task.data.id + '&token=' + auth.token(), '_blank')
    }

    const allowSubscription = () => {
        let contractor = task?.data?.contractor

        if (contractor) {
            if (contractor?.type?.is_subscription) {
                return true
            }
        }

        return false
    }

    const allowWarranty = () => {
        return task.warranties.length > 0
    }

    const showLabourPriceType = () => {
        switch (task.data?.labour_price_type) {
            case 'hourly':
                return trans('taskInfo.pricing.labour.hourly')
            case 'fixed':
                return trans('taskInfo.pricing.labour.fixed')
            case 'diagnostic_and_labour':
                return trans('taskInfo.pricing.labour.diagnostic_and_labour')
        }
    }

    function handleButtonSubmenuClick(e) {
        e.stopPropagation()
        e.preventDefault()

        setOpenButtonDropdown(addAddressReservationButtonRef.current)
    }

    const handleDelete = e => {
        let modal = questionRemoveModalRef.current

        setOpenButtonDropdown(null)

        modal.open()

        modal.onSuccess(() => {
            handleDestroy()
        })
    }

    const handleDestroy = () => {
        handleSetLoadingOnDelete(true)

        Api
            .post(`reservations/delete`, {
                id: task.data.id
            })
            .then(() => {
                history.push('/schedule/reservations?page=1')
            })
            .finally(() => {
                handleSetLoadingOnDelete(false)
            })
    }


    return (
        <>

            <Success
                mainMessage={trans('headings.success5')}
                secondaryMessage={trans('subheadings.success5')}
                ref={successModalRef}
            />

            <Success
                mainMessage={trans('headings.success14')}
                ref={successMailModalRef}
            />

            {/* Reclamation,continue,replicate modals */}
            <Success
                mainMessage={trans('headings.reclamation_success')}
                ref={reclamationModalRef}
            />

            <Success
                mainMessage={trans('headings.replicate_success')}
                ref={replicateModalRef}
            />

            <Success
                mainMessage={trans('headings.continue_success')}
                ref={continueModalRef}
            />
            {/* END */}

            <Error
                mainMessage={trans('headings.error3')}
                ref={errorModalRef}
            />

            <Error
                ref={applianceModalRef}
                mainMessage={trans('headings.success10')}
                secondaryMessage={trans('subheadings.chooseAnother')}
            />

            <Error
                ref={workDayModalRef}
                mainMessage={trans('messages.selectedEmployeeOnADayOff')}
                secondaryMessage={trans('subheadings.chooseAnother')}
            />

            <Question
                ref={reportModalRef}
                mainMessage={trans('headings.question5')}
            />

            <QuestionRemove
                ref={questionRemoveModalRef}
                mainMessage={trans('headings.confirmDelete')}
                secondaryMessage={trans('subheadings.confirmDelete')}
            />

            <AddComment
                ref={addCommentModalRef}
                callback={handleCommentAddedBeforeToggle}
            />

            <Employees
                ref={employeesModalRef}
                selected={task.data.performer ? task.data.performer.id : ''}
                type={task.data.performer ? task.data.performer.type : ''}
                hasPerformer={hasPerformer}
                canReassign={task.data.can_reassign}
                params={{
                    id: task.data.id,
                    appliance_category_id: task.data.appliancecategory ? task.data.appliancecategory.id : null,
                    lat: task.data.lat,
                    lon: task.data.lon,
                    visit_date: task.data.visit_date_ymd,
                    visit_period_from: task.data.visitperiod ? task.data.visitperiod.from : '',
                    visit_period_to: task.data.visitperiod ? task.data.visitperiod.to : '',
                    exec_time: task.data.exec_time
                }}
                onSave={handleChangePerformer}
            />

            <Address
                ref={addressModalRef}
                selected={task.data.address}
                params={{
                    lat: task.data.lat,
                    lon: task.data.lon,
                }}
                onSave={handleChangeAddress}
            />

            {props.loading
                ?
                <div className="panel-wrapper row">
                    <div className="panel">
                        <Skeleton height={35} className="row" count={8} />
                    </div>
                    <div className="panel">
                        <Skeleton height={35} className="row" count={8} />
                    </div>
                    <div className="panel">
                        <Skeleton height={35} className="row" count={8} />
                    </div>
                </div>
                :

                <div>
                    {
                        hasId ?
                            createPortal(<>
                                <Menu
                                    anchorEl={openButtonDropdown}
                                    keepMounted
                                    open={Boolean(openButtonDropdown)}
                                    onClose={() => setOpenButtonDropdown(null)}
                                    slotProps={{
                                        paper: {
                                            style: { overflow: 'visible' }
                                        }
                                    }}
                                    className='reservation-options-menu'
                                >
                                    <MenuItem onClick={handleCreate} >
                                        <img src={createNewImage} alt="create new" />
                                        {trans('buttons.new')}
                                    </MenuItem>
                                    {task.data.can_make_reclamation &&
                                        <MenuItem onClick={handleReclamation}>
                                            <img src={complaintImage} alt="reclamation" />
                                            {trans('buttons.reclamation')}
                                        </MenuItem>
                                    }
                                    {task.data.can_make_continuation &&
                                        <MenuItem onClick={handleContinue}>
                                            <img src={continueImage} alt="continue" />
                                            {trans('buttons.continuation')}
                                        </MenuItem>
                                    }
                                    <MenuItem onClick={handleReplicate}>
                                        <img src={duplicationImage} alt="duplicate" />
                                        {trans('buttons.duplicate')}
                                    </MenuItem>
                                    {task.data.final_status_id && task.data.final_status_id !== 13 ?
                                        <>
                                        </>
                                        :
                                        <MenuItem onClick={handleToggleReservationOpen}>
                                            <img src={task.data.is_open ? toggleReservationCloseIcon : toggleReservationOpenIcon} alt="toggle reservation" />
                                            {task.data.is_open ? trans('buttons.close') : trans('buttons.open')}
                                        </MenuItem>
                                    }
                                    <hr />
                                    <MenuItem onClick={handleSendSms}>
                                        <img src={sendSmsImage} alt="send message" />
                                        {trans('buttons.sendMessage')}
                                    </MenuItem>
                                    {task.data.can_send_confirmation &&
                                        <MenuItem onClick={handleSendConfirmation}>
                                            <img src={sendNotificationImage} alt="send notification" />
                                            {trans('buttons.sendNotification')}
                                        </MenuItem>
                                    }
                                    <hr />
                                    <MenuItem
                                        onMouseEnter={() => {
                                            setOpenApplianceDropdown(true)
                                            fetchMessageTemplates()
                                        }}
                                        onMouseLeave={() => setOpenApplianceDropdown(false)}
                                        ref={messageTemplatesButtonRef}
                                        className='with-menu'
                                    >
                                        <img src={sendOtherImage} alt="send other" />
                                        {trans('buttons.sendOtherNotification')}
                                        {Boolean(openApplianceDropdown) ?
                                            <Paper
                                                sx={{
                                                    position: "absolute",
                                                    right: 'calc(100% - 10px)',
                                                    top: 0,
                                                    width: "245px"
                                                }}
                                                className='reservation-options-paper'
                                            >
                                                <b
                                                    style={{
                                                        padding: '15px',
                                                        paddingBottom: 0,
                                                        display: 'block',
                                                    }}
                                                >
                                                    {trans('buttons.chooseFromTemplates')}
                                                </b>
                                                {loading ? (
                                                    <div
                                                        style={{
                                                            padding: '15px',
                                                            paddingTop: '5px'
                                                        }}
                                                    >
                                                        <Skeleton height={30} />
                                                        <Skeleton height={30} />
                                                        <Skeleton height={30} />
                                                    </div>
                                                ) : messageTemplates.length > 0 ? (
                                                    <>
                                                        {messageTemplates.map(option => (
                                                            <MenuItem key={option.id}
                                                                onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    handleOptionClick(option)
                                                                    setOpenButtonDropdown(null)
                                                                }}>
                                                                {option.subject}
                                                            </MenuItem>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <div
                                                        style={{
                                                            padding: '15px',
                                                            paddingTop: '5px'
                                                        }}
                                                    >
                                                        {trans('buttons.noTemplatesOptions')}
                                                    </div>
                                                )}

                                            </Paper>
                                            :
                                            <>
                                            </>
                                        }
                                    </MenuItem>
                                    {task.data.can_send_completion_message || task.data.can_send_report || task.data.can_make_pdf_order ?
                                        <hr />
                                        : ''}
                                    {task.data.can_send_completion_message &&
                                        <MenuItem onClick={handleSendCompletion}>
                                            {trans('buttons.sendNotification2')}
                                        </MenuItem>
                                    }
                                    {task.data.can_send_report &&
                                        <MenuItem onClick={handleSendReport}>
                                            {trans('buttons.sentReport')}
                                        </MenuItem>
                                    }
                                    {task.data.can_make_pdf_order &&
                                        <MenuItem onClick={handleShowPdfOrder}>
                                            {trans('buttons.downloadOffer')}
                                        </MenuItem>
                                    }
                                    {!task.data.is_copy ?
                                        <>
                                            <hr />
                                            <MenuItem
                                                onClick={handleDelete}
                                                sx={{
                                                    color: "#EC5252"
                                                }}
                                            >
                                                <img src={removeImage} alt="delete" />
                                                {trans('buttons.delete')}
                                            </MenuItem>
                                        </>
                                        :
                                        <>
                                        </>
                                    }
                                </Menu>
                                <button className='button-default' ref={addAddressReservationButtonRef} onClick={handleButtonSubmenuClick} disabled={!task.data.can_modify}>
                                    {trans('buttons.reservationOptions')}
                                    <img src={dropdownArrowImage} alt="dropdown arrow" />
                                </button>
                            </>, document.querySelector("#root > div > main > section > div > div.top-part"))
                            : <></>
                    }

                    {task.data.is_reassigned && auth.partnerId() != task.data.partner_id ?
                        <div className="alert warning">
                            {trans('messages.reservationPriority')} <b>{task.data.partner.name}</b>
                        </div>
                        :
                        ''
                    }

                    {(task?.data?.appliancecategory?.partner_id && task?.data?.appliancecategory?.partner_id != auth.partnerId() && task?.data?.partner_id != auth.partnerId()) &&
                        <div className="alert danger">
                            {trans('random.changeCategory')}
                        </div>
                    }

                    {task.data.is_child ?
                        <div>
                            {/* <p style={{ marginBottom: '8px' }}>
                                {String(task.data.reclamation) === '1' ? trans('buttons.reclamation') : trans('buttons.continuation')} {trans('random.reservationWithRefNumber')}:
                            </p> */}
                            <Link
                                to={`/reservations/edit/${task.data.parent_id}`}
                                style={{
                                    display: 'inline-block',
                                    padding: '6px 14px',
                                    borderRadius: '6px',
                                    backgroundColor: '#3A61FF',
                                    color: '#fff',
                                    fontSize: '13px',
                                    textDecoration: 'none',
                                    marginBottom: '15px'
                                }}
                            >
                                {String(task.data.reclamation) === '1' ? trans('buttons.reclamation') : trans('buttons.continuation')} {trans('random.reservationWithRefNumber')} {task.data.parent ? task.data.parent.reference_code : ''}
                            </Link>
                        </div>
                        :
                        task.data.children && task.data.children.length
                            ?
                            <div>
                                <p style={{ marginBottom: '8px' }}>
                                    {trans('random.reservationIncludes')} {task.data.children.length} {task.data.children.length == 1 ? trans('random.continuation') : trans('random.continuation2')}:
                                </p>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                    {task.data.children.map(c =>
                                        <Link
                                            key={c.id}
                                            to={`/reservations/edit/${c.id}`}
                                            style={{
                                                display: 'inline-block',
                                                padding: '6px 14px',
                                                borderRadius: '6px',
                                                backgroundColor: '#3A61FF',
                                                color: '#fff',
                                                fontSize: '13px',
                                                textDecoration: 'none',
                                                marginBottom: '15px'
                                            }}
                                        >
                                            {c.initialstatus && c.initialstatus.translation ? c.initialstatus.translation.name : ''} №{c.reference_code}
                                        </Link>
                                    )}
                                </div>
                            </div>
                            :
                            ''
                    }

                    {/* {task.data.is_subscription && task.data.subscription ?
                        <div className="alert warning">
                            Резервация към абонамент с реф. №: <b>{task?.data?.subscription?.ref || 'n/a'}</b>
                        </div>
                        :
                        ''
                    } */}

                    <form id="reservation" autoComplete="off" onSubmit={handleSubmit}>

                        <div className="row">

                            <div className="col">
                                <div className="pannel">
                                    <div className="head">
                                        <img src={clientHeadImage} alt="client" />
                                        <TaskInfoCustomHeadTabs isLandlord={task.data.is_landlord} />
                                    </div>

                                    {/* Field from here  */}
                                    <div className="row">
                                        <div className="col">
                                            <label htmlFor="name">
                                                {`${trans('labels.name')}${Number(task.data?.contractor?.type_id) !== 1 ? '*' : ''}`}
                                            </label>

                                            <Dropdown
                                                inputId="name"
                                                inputName="name"
                                                inputValue={task.data && task.data.customer ? task.data.customer.name : ''}
                                                inputIdName="customer_id"
                                                inputIdValue={task.data && task.data.customer_id ? task.data.customer_id : ''}
                                                inputPlaceholder={trans('random.searchByNamePhone')}
                                                inputClassName={task.validations.name ? 'validate' : ''}
                                                inputDisabled={task.data.is_child || !task.data.can_modify}
                                                url="customers/search"
                                                renderInputText={data => {
                                                    return data.name
                                                }}
                                                renderText={data => {
                                                    return (
                                                        <div style={{ fontSize: '12px' }}>
                                                            {data.name} {data.lastname}
                                                            <br />
                                                            <span>
                                                                {trans('random.phone')} {data.phone_formatted || trans('messages.notSelected')}
                                                            </span>
                                                        </div>
                                                    )
                                                }}
                                                onChange={handleCustomerChange}
                                            />
                                        </div>
                                        <div className="col">
                                            <label htmlFor="lastname">
                                                {`${trans('labels.lastname')}${Number(task.data?.contractor?.type_id) !== 1 ? '*' : ''}`}
                                            </label>
                                            <input
                                                type="text"
                                                className={task.validations.lastname ? 'validate' : ''}
                                                name="lastname"
                                                id="lastname"
                                                value={task.data && task.data.customer ? task.data.customer.lastname : ''}
                                                disabled={task.data.is_child || !task.data.can_modify}
                                                onChange={handleCustomerInputChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <label>
                                                {trans('labels.typeClient')}
                                            </label>
                                            <select
                                                value={task.data && task.data.contractor ? task.data.contractor?.type_id : ''}
                                                name="type"
                                                onChange={handleContractorsAll}
                                                disabled={task.data.is_child || !task.data.can_modify}
                                            >
                                                <option value="" selected>
                                                    {trans('random.person')}
                                                </option>
                                                {task.contractors.types.map(type =>
                                                    <option key={'ct-' + type.id} value={type.id}>
                                                        {type.name}
                                                    </option>
                                                )}
                                            </select>
                                        </div>
                                        {task.data && task.data.contractor && task.data.contractor.type_id
                                            ?
                                            <div className="col">
                                                <label htmlFor="contractor_id">
                                                    {trans('labels.contractor')}
                                                </label>
                                                <select
                                                    value={task.data && task.data.contractor && task.data.contractor.id ? task.data.contractor.id : ''}
                                                    className={task.validations.contractor_id ? 'validate' : ''}
                                                    name="contractor_id"
                                                    id="contractor_id"
                                                    onChange={handleSelectedContractor}
                                                    disabled={task.data.is_child || !task.data.can_modify}
                                                >
                                                    <option value="" disabled>

                                                    </option>
                                                    {task.contractors.all && task.contractors.all.map(each =>
                                                        <option key={'contractor-' + each.id} value={each.id}>
                                                            {each.name}
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                            :
                                            ''
                                        }
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <label>
                                                {trans('labels.clientNo')}
                                            </label>
                                            <input
                                                type="text"
                                                name="purchase_order"
                                                value={task.data && task.data.purchase_order ? task.data.purchase_order : ''}
                                                disabled={task.data.is_child || !task.data.can_modify}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                    {isAddress() &&
                                        <div className="row">
                                            <div className="col">
                                                <label htmlFor="address">
                                                    {trans('labels.address')}*
                                                </label>

                                                <input
                                                    type="text"
                                                    name="address"
                                                    className={task.validations.address || task.validations.lat || task.validations.lon ? 'validate' : ''}
                                                    value={task.data.address ? task.data.address : ''}
                                                    onClick={showAddressMap}
                                                    disabled={task.data.is_child || !task.data.can_modify}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col">
                                                <label htmlFor="postcode">
                                                    {trans('labels.postCode')}
                                                </label>
                                                <div style={{ display: 'flex' }}>
                                                    <input
                                                        value={task.data && task.data.postcode ? task.data.postcode : ''}
                                                        type="text"
                                                        className={task.validations.postcode ? 'validate' : ''}
                                                        name="postcode"
                                                        id="postcode"
                                                        onChange={handleInputChange}
                                                        disabled={task.data.is_child || !task.data.can_modify}
                                                        style={{
                                                            borderTopRightRadius: 0,
                                                            borderBottomRightRadius: 0,
                                                        }}
                                                    />
                                                    {task.data.congestion_price > 0
                                                        ?
                                                        <div style={{ background: '#f0ad4e', width: '40px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderTopRightRadius: '3px', borderBottomRightRadius: '3px' }}>
                                                            <img
                                                                src={carIcon}
                                                                height={18}
                                                                data-tip
                                                                data-for="congestion_tooltip"
                                                            />
                                                            <ReactTooltip
                                                                effect="solid"
                                                                id="congestion_tooltip"
                                                            >
                                                                {trans('messages.fallsInCongestionCharge')}
                                                            </ReactTooltip>
                                                        </div>
                                                        :
                                                        ''
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                    }

                                    {isAddress() &&
                                        <>
                                            <input type="hidden" name="lat" value={task.data?.lat || ''} />
                                            <input type="hidden" name="lon" value={task.data?.lon || ''} />
                                        </>
                                    }

                                    <div className="row">
                                        <div className="col">
                                            <label>
                                                {trans('labels.phone')}*
                                            </label>
                                            <PhoneField
                                                codeValue={task.data.phone_code || auth.phoneCode()}
                                                numberValue={task.data && task.data.phone ? task.data.phone : ''}
                                                onCodeChange={e => {
                                                    setTask(prev => ({
                                                        ...prev,
                                                        data: {
                                                            ...prev.data,
                                                            'phone_code': e.target.value
                                                        }
                                                    }))
                                                }}
                                                onNumberChange={e => {
                                                    setTask(prev => ({
                                                        ...prev,
                                                        data: {
                                                            ...prev.data,
                                                            'phone': e.target.value
                                                        }
                                                    }))
                                                }}
                                                placeholder={trans('labels.phone')}
                                                disabled={task.data.is_child || !task.data.can_modify}
                                                codeName="phone_code"
                                                numberName="phone"
                                                validate={task.validations.phone ? 'validate' : ''}
                                            // disabledCodeSelect
                                            />
                                        </div>

                                        <div className="col">
                                            <label htmlFor="email">
                                                {trans('labels.email')}
                                            </label>
                                            <input
                                                value={task.data && task.data.email ? task.data.email : ''}
                                                type="text"
                                                className={task.validations.email ? 'validate' : ''}
                                                name="email"
                                                id="email"
                                                disabled={task.data.is_child || !task.data.can_modify}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>

                                    {/* //NEW: Допълнителни телефонни номера */}
                                    {(task.data.phones || []).length ?
                                        <div className="row">
                                            <div className="col">
                                                {(task.data.phones || []).map((phone, idx) => (
                                                    <div key={idx} className='extra-contact-container'>
                                                        <PhoneField
                                                            codeValue={task.data.phones[idx].country_code}
                                                            numberValue={task.data.phones[idx].phone_number}
                                                            onCodeChange={e => handleAdditionalPhoneChange(idx, 'country_code', e.target.value)}
                                                            onNumberChange={e => handleAdditionalPhoneChange(idx, 'phone_number', e.target.value)}
                                                            placeholder={trans('labels.new_additional_phone')}
                                                            disabled={task.data.is_child || !task.data.can_modify}
                                                        />
                                                        <input
                                                            type="text"
                                                            value={task.data.phones[idx].contact_person_name}
                                                            onChange={e => handleAdditionalPhoneChange(idx, 'contact_person_name', e.target.value)}
                                                            placeholder={trans('labels.contact_person_name')}
                                                            disabled={task.data.is_child || !task.data.can_modify}
                                                        />
                                                        <Button
                                                            onClick={() => handleRemoveAdditionalPhone(idx)}
                                                            disabled={task.data.is_child || !task.data.can_modify}
                                                            sx={{
                                                                width: "40px",
                                                                height: "40px",
                                                                borderRadius: "50%",
                                                                minWidth: "initial",
                                                                flexShrink: 0
                                                            }}
                                                        >
                                                            <img
                                                                src={removeImage}
                                                                alt="Remove"
                                                                style={{
                                                                    width: "17px",
                                                                    objectFit: "contain"
                                                                }}
                                                            />
                                                        </Button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        :
                                        <>
                                        </>
                                    }
                                    <div className="row">
                                        <div className="col">
                                            <button
                                                className="button button-add button-small"
                                                style={{ width: "fit-content" }}
                                                type="button"
                                                onClick={handleAddAdditionalPhone}
                                                disabled={task.data.is_child || !task.data.can_modify}
                                            >
                                                {trans('labels.new_additional_phone')}
                                            </button>
                                        </div>
                                    </div>
                                    <TaskInfoInvoiceFields
                                        task={task}
                                        handleInputChange={handleInputChange}
                                        withInvoice={task.data.with_invoice}
                                        handleWithInvoiceChange={withInvoice => {
                                            setTask(prev => ({
                                                ...prev,
                                                data: {
                                                    ...prev.data,
                                                    "with_invoice": withInvoice
                                                }
                                            }))
                                        }}
                                    />
                                    {/* Field to here  */}
                                </div>
                            </div>

                            <div className="col">
                                {/* //NEW: Нов компонент за уреди, понеже вече можем да имаме няколко уреда */}
                                <div className="pannel">
                                    <AppliancesField
                                        task={task}
                                        setTask={setTask}
                                        allowSubscription={allowSubscription}
                                        allowWarranty={allowWarranty}
                                    />
                                </div>
                            </div>

                        </div>
                        {hasId ?
                            <div className="row">
                                <div className="col">
                                    <TaskInfoComments
                                        reservationId={task.data.id}
                                        data={task.data}
                                    />
                                </div>
                                <div className="col">
                                    <TaskInfoTodos
                                        reservationId={task.data.id}
                                        data={task.data}
                                    />
                                </div>
                            </div>
                            :
                            <>
                            </>
                        }
                        <div className="row">
                            <div className="col">
                                <div className="pannel total-field">
                                    <div className="head">
                                        <img src={visitpriceHeadImage} alt="visitation" />
                                        {trans('random.visitAndPrice')}
                                        {task.data.reference_code ?
                                            <div className="ref-number">
                                                <img src={hastagImage} alt='Ref number' />
                                                <div className='right'>
                                                    <span>
                                                        {trans('labels.refNumber')}
                                                    </span>
                                                    <b>
                                                        {task.data.reference_code}
                                                    </b>
                                                </div>
                                            </div>
                                            :
                                            <>
                                            </>
                                        }
                                        {task.data.created_dmy ?
                                            <div className='created-at'>
                                                <img src={calendarImage} alt='Calendar' />
                                                <div className='right'>
                                                    <span>
                                                        {trans('labels.creationDate')}
                                                    </span>
                                                    <b>
                                                        {task.data.created_dmy}
                                                    </b>
                                                </div>
                                            </div>
                                            :
                                            <>
                                            </>
                                        }
                                    </div>


                                    <div className="row">
                                        <div className="col">
                                            <label htmlFor="visit_date">
                                                {trans('labels.visitDate')}*
                                            </label>
                                            <input
                                                type="date"
                                                value={task.data ? task.data.visit_date_ymd : ''}
                                                name="visit_date"
                                                id="visit_date"
                                                className={task.validations.visit_date ? 'validate' : ''}
                                                onChange={handleChangeDate}
                                                disabled={!task.data.can_modify}
                                            />
                                        </div>
                                        <div className="col">
                                            <label htmlFor="visit_period_id">
                                                {trans('labels.visitHour')}*
                                            </label>
                                            <select
                                                value={task.data && task.data.visit_period_id ? task.data.visit_period_id : ''}
                                                name="visit_period_id"
                                                id="visit_period_id"
                                                className={task.validations.visit_period_id ? 'validate' : ''}
                                                onChange={handleChangePeriod}
                                                disabled={!task.data.can_modify}
                                            >
                                                <option value="" selected>
                                                    {trans('random.select')}
                                                </option>
                                                {task.reservations.visitperiods.map(visitperiod =>
                                                    <option value={visitperiod.id} key={'vp-' + visitperiod.id}>
                                                        {visitperiod.period}
                                                    </option>
                                                )}
                                            </select>
                                        </div>
                                        <div className="col">
                                            <label htmlFor="performer">
                                                {trans('labels.setTo')}*
                                            </label>

                                            <input
                                                id="performer"
                                                type="text"
                                                value={task.data && task.data.performer
                                                    ?
                                                    task.data.performer.type === 'App\\Employee' || task.data.performer.type === 'App\\Models\\Employee' || task.data.performer.type === 'employee'
                                                        ?
                                                        `${task.data.performer.name || ''} ${task.data.performer.lastname || ''}`.trim()
                                                        :
                                                        task.data.performer.name || ''
                                                    : ''}
                                                onClick={showEmployeesSelect}
                                                readOnly
                                                disabled={!task.data.can_modify}
                                                className={task.validations.performer_id ? 'validate' : ''}
                                            />

                                            <input
                                                type="hidden"
                                                name="performer_id"
                                                value={task.data && task.data.performer ? task.data.performer.id : ''}
                                            />

                                            <input
                                                type="hidden"
                                                name="performer_type"
                                                value={task.data && task.data.performer ? task.data.performer.type : ''}
                                            />

                                        </div>
                                        {task.data?.performer &&
                                            (task.data.performer.type === 'App\\Partner' ||
                                                task.data.performer.type === 'App\\Models\\Partner') &&
                                            <div className="col">
                                                <label htmlFor="parts_provider">
                                                    {trans('labels.partsFrom') || 'Parts from'}*
                                                </label>
                                                <select
                                                    value={task.data && task.data.parts_provider ? task.data.parts_provider : ''}
                                                    name="parts_provider"
                                                    id="parts_provider"
                                                    className={task.validations.parts_provider ? 'validate' : ''}
                                                    onChange={e => {
                                                        setTask(prev => ({
                                                            ...prev,
                                                            data: {
                                                                ...prev.data,
                                                                parts_provider: e.target.value
                                                            }
                                                        }))
                                                    }}
                                                    disabled={hasId || !task.data.can_modify}
                                                >
                                                    <option value="partner">
                                                        {trans('labels.partner') || 'Partner'}
                                                    </option>

                                                    <option value="owner">
                                                        {trans('labels.ourOwn') || 'Our own'}
                                                    </option>

                                                </select>
                                            </div>
                                        }
                                        {task.data?.performer &&
                                            (task.data.performer.type === 'App\\Partner' ||
                                                task.data.performer.type === 'App\\Models\\Partner') &&
                                            <div className="col">
                                                <label htmlFor="pos_type">
                                                    {trans('labels.paymentWillBeTakenFrom') || 'Payment will be taken from'}*
                                                </label>
                                                <select
                                                    value={task.data && task.data.pos_type ? task.data.pos_type : ''}
                                                    name="pos_type"
                                                    id="pos_type"
                                                    className={task.validations.pos_type ? 'validate' : ''}
                                                    onChange={e => {
                                                        setTask(prev => ({
                                                            ...prev,
                                                            data: {
                                                                ...prev.data,
                                                                pos_type: e.target.value
                                                            }
                                                        }))
                                                    }}
                                                    disabled={hasId || !task.data.can_modify}
                                                >
                                                    <option value="PARTNER">
                                                        {trans('labels.partner') || 'Partner'}
                                                    </option>

                                                    <option value="OWNER">
                                                        {trans('labels.us') || 'Us'}
                                                    </option>

                                                </select>
                                            </div>
                                        }
                                        <div className="col">
                                            <label htmlFor="initial_status_id">
                                                {trans('labels.initialStatus')}*
                                            </label>
                                            <select
                                                value={task.data && task.data.initial_status_id ? task.data.initial_status_id : ''}
                                                name="initial_status_id"
                                                id="initial_status_id"
                                                className={task.validations.initial_status_id ? 'validate' : ''}
                                                onChange={handleChangeInitialStatus}
                                                disabled={!task.data.can_modify || !task.data.can_modify_initial_status}
                                            >
                                                <option disabled>
                                                    {trans('random.select')}
                                                </option>
                                                {task.reservations.statuses[1] && task.reservations.statuses[1].map(status =>
                                                    <option
                                                        key={'s-' + status.id}
                                                        value={status.id}
                                                        disabled={!status.selectable}
                                                    >
                                                        {status?.translation?.name}
                                                    </option>
                                                )}
                                            </select>
                                        </div>
                                        {/* Само при редакция */}
                                        <div className="col">
                                            <label htmlFor="final_status_id">
                                                {trans('labels.finalStatus')}
                                            </label>
                                            <select
                                                value={task.data && task.data.final_status_id ? task.data.final_status_id : ''}
                                                name="final_status_id"
                                                id="final_status_id"
                                                className={task.validations.final_status_id ? 'validate' : ''}
                                                onChange={handleChangeFinalStatus}
                                                disabled={!hasId || !task.data.can_modify || !task.data.initial_status_id}
                                            >
                                                <option value="" disabled>
                                                    {trans('random.select')}
                                                </option>
                                                {task.reservations.statuses[2] && task.reservations.statuses[2].map(status =>
                                                    <option value={status.id} key={'s-' + status.id}>
                                                        {status.translation?.name}
                                                    </option>
                                                )}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <label>
                                                {trans('labels.typeAndTime')}
                                            </label>
                                            <Dropdown
                                                inputValue={task.data.exec_time_in_minutes}
                                                inputIdValue={task.data.type_id}
                                                inputIdName="type_id"
                                                inputDisabled={!task.data.can_modify}
                                                filter={true}
                                                data={task.reservations.types}
                                                // renderInputText={data => data.minutes}
                                                renderText={data => (
                                                    `${data.name} ${data.minutes} мин.`
                                                )}
                                                onChange={handleTypeChange}
                                            />

                                            <input type="hidden" name="exec_time" value={task.data.exec_time} readOnly />
                                        </div>
                                        {(task.data.labour_price_type === 'hourly' || task.data.labour_price_type === 'category_hourly') &&
                                            <div className="col">
                                                <label>
                                                    {trans('labels.workHours')}
                                                </label>
                                                <input
                                                    value={task.data?.work_hours || ''}
                                                    type="number"
                                                    step="1"
                                                    min="1"
                                                    name="work_hours"
                                                    // disabled={task.data.is_child || !task.data.can_modify}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        }
                                    </div>

                                    <div className="total-price">

                                        <div className="left">
                                            <div className='table-scroller'>
                                                <table>
                                                    <tbody>
                                                        {(task.data.other_expenses || []).length > 0 ?
                                                            <tr>
                                                                <td>

                                                                </td>
                                                                <td colSpan={3}>
                                                                    <div
                                                                        className='head'
                                                                        style={{
                                                                            marginBottom: 0
                                                                        }}
                                                                    >
                                                                        {trans('tabs.basic')}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            :
                                                            <>
                                                            </>
                                                        }
                                                        {task?.data?.subscription
                                                            ?
                                                            <tr>
                                                                <td>
                                                                    <Checkbox
                                                                        id="is_subscription"
                                                                        name="is_subscription"
                                                                        value="1"
                                                                        checked={task.data.is_subscription ? true : false}
                                                                        onChange={handleCheckboxChange}
                                                                        disabled={!task.data.can_modify}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    {trans('labels.repairSubscription')}
                                                                </td>
                                                                <td>

                                                                </td>
                                                                <td>

                                                                </td>
                                                            </tr>
                                                            :
                                                            ''
                                                        }

                                                        {String(task.data.reclamation) === '1'
                                                            ?
                                                            <tr>
                                                                <td>
                                                                    <Checkbox
                                                                        id="customer_fault"
                                                                        name="customer_fault"
                                                                        value="1"
                                                                        checked={task.data.customer_fault ? true : false}
                                                                        onChange={handleCheckboxChange}
                                                                        disabled={!task.data.can_modify}
                                                                        size="small"
                                                                        sx={{ padding: 0 }}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    {trans('labels.byVin')}
                                                                </td>
                                                                <td>

                                                                </td>
                                                                <td>

                                                                </td>
                                                            </tr>
                                                            :
                                                            ''
                                                        }
                                                        {task.data.diagnostic_price > 0 &&
                                                            <tr>
                                                                <td>

                                                                </td>
                                                                <td>
                                                                    {trans('labels.diagnosticPrice')}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        name="diagnostic_price_formatted"
                                                                        value={task.data.diagnostic_price_formatted || '0.00'}
                                                                        onChange={handleInputChange}
                                                                        disabled={!task.data.can_modify}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <b>
                                                                        <span>{trans('random.dds')}</span> <span>{task.data.diagnostic_vat_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}</span>
                                                                    </b>
                                                                    <b>
                                                                        <span>{trans('random.net')}</span> <span>{task.data.diagnostic_net_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}</span>
                                                                    </b>
                                                                    {task.data.diagnostic_payment
                                                                        ?
                                                                        <>
                                                                            <div className="payment-label" data-tip data-for="diagnostic-payment">
                                                                                {task.data.diagnostic_payment.paymentmethod && task.data.diagnostic_payment.paymentmethod.translation && task.data.diagnostic_payment.paymentmethod.translation.name}
                                                                            </div>
                                                                            <ReactTooltip
                                                                                id="diagnostic-payment"
                                                                                effect="solid"
                                                                            >
                                                                                {trans('random.marketFrom')} {task.data.diagnostic_payment.employee ? `${task.data.diagnostic_payment.employee.name} ${task.data.diagnostic_payment.employee.lastname}` : trans('random.theEmployee')} {trans('random.on')} {task.data.diagnostic_payment.created_at_dmy}
                                                                            </ReactTooltip>
                                                                        </>
                                                                        :
                                                                        ''
                                                                    }
                                                                </td>
                                                            </tr>
                                                        }
                                                        {!(Number(task.data.is_copy) && !(task.data.can_see_labour_price)) && (
                                                            <tr>
                                                                <td>
                                                                    <Checkbox
                                                                        name="calculate_labour_price"
                                                                        value="1"
                                                                        checked={task.data.calculate_labour_price ? true : false}
                                                                        sx={{ padding: 0 }}
                                                                        disabled={!task.data.can_modify}
                                                                        onChange={handleCheckboxChange}
                                                                        size='small'
                                                                    />

                                                                </td>
                                                                <td>
                                                                    {trans('labels.labourPrice')}
                                                                    <img data-tip data-for="labour-charge" className="info-icon" src={infoIcon} />
                                                                    <ReactTooltip
                                                                        id="labour-charge"
                                                                        effect="solid"
                                                                    >
                                                                        {trans('labels.labourPrice')}: {task.data.labour_clean_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}
                                                                        <br />
                                                                        {trans('labels.congestionPrice')}: {task.data.congestion_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}
                                                                    </ReactTooltip>
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        name="labour_price_formatted"
                                                                        value={task.data.labour_price_formatted || '0.00'}
                                                                        onChange={handleInputChange}
                                                                        disabled={!task.data.can_modify}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <b>
                                                                        <span>{trans('random.dds')}</span> <span>{task.data.labour_vat_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}</span>
                                                                    </b>
                                                                    <b>
                                                                        <span>{trans('random.net')}</span> <span>{task.data.labour_net_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}</span>
                                                                    </b>
                                                                    {task.data.labour_payment
                                                                        ?
                                                                        <>
                                                                            <div className="payment-label" data-tip data-for="labour-payment">
                                                                                {task.data.labour_payment.paymentmethod && task.data.labour_payment.paymentmethod.translation && task.data.labour_payment.paymentmethod.translation.name}
                                                                            </div>
                                                                            <ReactTooltip
                                                                                id="labour-payment"
                                                                                effect="solid"
                                                                            >
                                                                                {trans('random.marketFrom')} {task.data.labour_payment.employee ? `${task.data.labour_payment.employee.name} ${task.data.labour_payment.employee.lastname}` : trans('random.theEmployee')} {trans('random.on')} {task.data.labour_payment.created_at_dmy}
                                                                            </ReactTooltip>
                                                                        </>
                                                                        :
                                                                        ''
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )}
                                                        {task.data.transport_price > 0 &&
                                                            <tr>
                                                                <td>

                                                                </td>
                                                                <td>
                                                                    {trans('labels.transportPrice')}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        name="transport_price_formatted"
                                                                        value={task.data.transport_price_formatted || '0.00'}
                                                                        onChange={handleInputChange}
                                                                        disabled={!task.data.can_modify}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <b>
                                                                        <span>{trans('random.dds')}</span> <span>{task.data.transport_vat_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}</span>
                                                                    </b>
                                                                    <b>
                                                                        <span>{trans('random.net')}</span> <span>{task.data.transport_net_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}</span>
                                                                    </b>
                                                                    {task.data.transport_payment
                                                                        ?
                                                                        <>
                                                                            <div className="payment-label" data-tip data-for="transport-payment">
                                                                                {task.data.transport_payment.paymentmethod && task.data.transport_payment.paymentmethod.translation && task.data.transport_payment.paymentmethod.translation.name}
                                                                            </div>
                                                                            <ReactTooltip
                                                                                id="transport-payment"
                                                                                effect="solid"
                                                                            >
                                                                                {trans('random.marketFrom')} {task.data.transport_payment.employee ? `${task.data.transport_payment.employee.name} ${task.data.transport_payment.employee.lastname}` : trans('random.theEmployee')} {trans('random.on')} {task.data.transport_payment.created_at_dmy}
                                                                            </ReactTooltip>
                                                                        </>
                                                                        :
                                                                        ''
                                                                    }
                                                                </td>
                                                            </tr>
                                                        }
                                                        {!(task.data.is_copy && !Number(task.data.can_see_part_prices)) && (
                                                            <tr>
                                                                <td>

                                                                </td>
                                                                <td>
                                                                    <label className="flex">
                                                                        {trans('labels.partsPrice')} <img data-tip data-for="parts-charge" className="info-icon" src={infoIcon} />
                                                                    </label>
                                                                    <ReactTooltip
                                                                        id="parts-charge"
                                                                        effect="solid"
                                                                    >
                                                                        {task.data.parts_price > 0
                                                                            ?
                                                                            trans('messages.includesPartsAndStock')
                                                                            :
                                                                            trans('messages.includesStockParts')
                                                                        }
                                                                    </ReactTooltip>
                                                                </td>
                                                                <td>
                                                                    <input type="text" disabled value={task.data.parts_price_formatted || '0.00'} />
                                                                </td>
                                                                <td>
                                                                    <b>
                                                                        <span>{trans('random.dds')}</span> <span>{task.data.parts_vat_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}</span>
                                                                    </b>
                                                                    <b>
                                                                        <span>{trans('random.net')}</span> <span>{task.data.parts_net_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}</span>
                                                                    </b>
                                                                    {task.data.parts_payment
                                                                        ?
                                                                        <>
                                                                            <div className="payment-label" data-tip data-for="parts-payment">
                                                                                {task.data.parts_payment.paymentmethod && task.data.parts_payment.paymentmethod.translation && task.data.parts_payment.paymentmethod.translation.name}
                                                                            </div>
                                                                            <ReactTooltip
                                                                                id="parts-payment"
                                                                                effect="solid"
                                                                            >
                                                                                {trans('random.marketFrom')} {task.data.parts_payment.employee ? `${task.data.parts_payment.employee.name} ${task.data.parts_payment.employee.lastname}` : trans('random.theEmployee')} {trans('random.on')} {task.data.parts_payment.created_at_dmy}
                                                                            </ReactTooltip>
                                                                        </>
                                                                        :
                                                                        ''
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )}
                                                        {(task.data.other_expenses || []).length > 0 ?
                                                            <>
                                                                <tr>
                                                                    <td>

                                                                    </td>
                                                                    <td colSpan={3}>
                                                                        <div
                                                                            className='head'
                                                                            style={{
                                                                                marginBottom: 0
                                                                            }}
                                                                        >
                                                                            {trans('tabs.others')}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                {(task.data.other_expenses || []).map((oe) =>
                                                                    <tr key={oe.id}>
                                                                        <td>

                                                                        </td>
                                                                        <td>
                                                                            <label className="flex">
                                                                                {oe.name}
                                                                                {oe.quantity && (
                                                                                    <span style={{ fontSize: '12px', color: '#888' }}>
                                                                                        {' '}x {oe.quantity}
                                                                                    </span>
                                                                                )}
                                                                            </label>
                                                                        </td>
                                                                        <td>
                                                                            <input type="text" disabled value={oe.total_gross_price_formatted || '0.00'} />
                                                                        </td>
                                                                        <td>
                                                                            <b>
                                                                                <span>{trans('random.dds')}</span> <span>{oe.vat_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}</span>
                                                                            </b>
                                                                            <b>
                                                                                <span>{trans('random.net')}</span> <span>{oe.net_price_formatted || '0.00'} {task.data.currency && task.data.currency.name}</span>
                                                                            </b>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </>
                                                            :
                                                            <>
                                                            </>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>

                                            {task?.data?.warranty
                                                ?
                                                <input type="hidden" name="is_warranty" value={task.data.is_warranty ? 1 : 0} />
                                                :
                                                ''
                                            }
                                        </div>

                                        {/* обща цена */}
                                        <div className="right" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                            <table className='gross'>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            {trans('random.paidGross')}
                                                        </td>
                                                        <td>
                                                            {task.data.paid_gross_price_formatted || '0.00'} {task.data.currency ? task.data.currency.name : ''}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {trans('random.leftToPayGross')}
                                                        </td>
                                                        <td>
                                                            {task.data.unpaid_gross_price_formatted || '0.00'} {task.data.currency ? task.data.currency.name : ''}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div style={{
                                                flexShrink: 0,
                                                marginLeft: '50px',
                                                textAlign: 'right'
                                            }}>
                                                <b>
                                                    {task.data.total_price_formatted || '0.00'} {task.data.currency ? task.data.currency.name : ''}
                                                </b>
                                                <table className='net'>
                                                    <tr>
                                                        <td style={{ textAlign: 'left' }}>
                                                            {trans('random.dds')}
                                                        </td>
                                                        <td className="right">
                                                            {task.data.total_vat_price_formatted || '0.00'} {task.data.currency ? task.data.currency.name : ''}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ textAlign: 'left' }}>
                                                            {trans('random.net')}
                                                        </td>
                                                        <td className="right">
                                                            {task.data.total_net_price_formatted || '0.00'} {task.data.currency ? task.data.currency.name : ''}
                                                        </td>
                                                    </tr>
                                                </table>

                                                {task.data.total_payment
                                                    ?
                                                    <>
                                                        <div>
                                                            <div className="payment-label" data-tip data-for="total-payment" style={{ position: 'relative' }}>
                                                                {task.data.total_payment.paymentmethod && task.data.total_payment.paymentmethod.translation && task.data.total_payment.paymentmethod.translation.name}
                                                            </div>
                                                            <ReactTooltip
                                                                id="total-payment"
                                                                effect="solid"
                                                            >
                                                                {trans('random.marketFrom')} {task.data.total_payment.employee ? `${task.data.total_payment.employee.name} ${task.data.total_payment.employee.lastname}` : trans('random.theEmployee')} {trans('random.on')} {task.data.total_payment.created_at_dmy}
                                                            </ReactTooltip>
                                                        </div>
                                                    </>
                                                    :
                                                    ''
                                                }
                                            </div>

                                        </div>


                                    </div>

                                    {showLabourPriceType() &&
                                        <>
                                            <br />
                                            <p style={{ fontSize: '12px' }}>
                                                {showLabourPriceType()}
                                            </p>
                                        </>
                                    }

                                </div>
                            </div>
                        </div>

                        {hasId ?
                            <div className="row">
                                <div className="col">
                                    <div className="pannel">
                                        <div className="head">
                                            <img src={visitpriceHeadImage} alt="visitation" />
                                            {trans('tabs.images')}
                                        </div>
                                        <ReservationImages data={props.data} />
                                    </div>
                                </div>
                            </div>
                            :
                            <>
                            </>
                        }

                        <div className="row buttons-holder">
                            {task.loading ?
                                <img src={loader} alt="loading" />
                                :
                                <>
                                    <button className="button button-default" onClick={() => history.go(-1)}>
                                        {trans('buttons.cancel')}
                                    </button>
                                    <button className="button button-primary" onClick={handleSave}>
                                        {trans('buttons.save')}
                                    </button>
                                </>
                            }
                        </div>
                    </form>
                </div>
            }
            <AddOrEditSmsMessage ref={smsModalRef} />
        </>
    )
}

export default React.memo(TaskInfo, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})